var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6473_5028)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.40039 0L10.2663 10.2667H11.7329L1.46628 0H-4.40039ZM-4.40039 22L10.2663 11.7333H11.7329L1.46628 22H-4.40039Z",
    fill: "#F1D07C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7329 10.2667H10.2663L20.5329 0H26.3996L11.7329 10.2667ZM11.7329 11.7333H10.2663L20.5329 22H26.3996L11.7329 11.7333ZM7.33294 10.2667L-4.40039 8.8V13.2L7.33294 11.7333V10.2667ZM14.6663 10.2667L26.3996 8.8V13.2L14.6663 11.7333V10.2667ZM10.2663 7.33333L8.79961 0H13.1996L11.7329 7.33333H10.2663ZM10.2663 14.6667L8.79961 22H13.1996L11.7329 14.6667",
    fill: "#F1D07C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 14.6668C13.0247 14.6668 14.6663 13.0252 14.6663 11.0002C14.6663 8.97512 13.0247 7.3335 10.9997 7.3335C8.97463 7.3335 7.33301 8.97512 7.33301 11.0002C7.33301 13.0252 8.97463 14.6668 10.9997 14.6668Z",
    fill: "#DB5F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 13.1998C12.2148 13.1998 13.1998 12.2148 13.1998 10.9998C13.1998 9.78478 12.2148 8.7998 10.9998 8.7998C9.78478 8.7998 8.7998 9.78478 8.7998 10.9998C8.7998 12.2148 9.78478 13.1998 10.9998 13.1998Z",
    fill: "#F1D07C"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#D2D5D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6473_5028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk);
export default __webpack_public_path__ + "static/media/mk.5f8fd53412ac84f09fd276efbc8f6331.svg";
export { ForwardRef as ReactComponent };